import React, { useState, useEffect } from 'react';
import '../styles/FooterContacto.css';

const FooterContacto = () => {
  const [contactData, setContactData] = useState({
    email: 'contacto@aither-enterprise.com',
    telefono: '+56 9 XXXX XXXX',
    whatsapp: 'https://wa.me/56912345678'
  });

  useEffect(() => {
    // Cargar datos de contacto desde JSON
    fetch('/data/contacto.json')
      .then(res => res.json())
      .then(data => setContactData(data))
      .catch(err => console.error('Error cargando contacto.json:', err));
  }, []);

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-contacto">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Contacto</h3>
            
            <div className="contact-email">
              <p>
                Email: <a href={`mailto:${contactData.email}`}>{contactData.email}</a>
              </p>
            </div>

            <div className="contact-phone">
              <p className="contact-label">Llamada o WhatsApp</p>
              <div className="phone-options">
                <a href={`tel:${contactData.telefono}`} className="phone-call-button" title="Llamar">
                  <span className="phone-icon">☎</span>
                  <span className="phone-number">{contactData.telefono}</span>
                </a>
                <a href={contactData.whatsapp} target="_blank" rel="noopener noreferrer" className="whatsapp-button-new" title="WhatsApp">
                  <img src="/assets/wsp.png" alt="WhatsApp" className="whatsapp-icon" />
                </a>
              </div>
              <p className="contact-hint">Disponible por voz o mensaje</p>
            </div>
          </div>
          
          <div className="footer-section education-link-section">
            <h3>Más de AITher</h3>
            <p className="education-link-text">
              ¿También buscas formación personalizada?
            </p>
            <a 
              href="https://aither-educacion.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="education-link"
            >
              Descubre AITher Educación →
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} AITher Enterprise. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterContacto;
